import { rMessageBox } from "../Slice/alertSlice";

export const message = (isAlert, message) => (dispatch) => {
    dispatch(rMessageBox({ isAlert, message }));
  };